<template>
    <div class="bg-white">
        <header class="relative bg-white">
            <nav aria-label="Top" class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="border-b border-gray-200 px-4 pb-14 md:px-0 md:pb-0">
                    <div class="h-32 flex items-center justify-between">
                        <!-- Logo -->
                        <div class="flex-1 flex">
                            <router-link :to="{ name: 'home' }">
                                <span class="sr-only">uChowańca</span>
                                <img class="lg:h-16 h-14 w-auto"
                                     src="https://uchowanca.pl/img/logotypes/uchowanca-logo.svg" alt=""/>
                            </router-link>
                        </div>

                        <!-- Flyout menus -->
                        <PopoverGroup class="z-30 absolute bottom-0 inset-x-0 md:static md:flex-1 md:self-stretch">
                            <div
                                class="border-t h-14 px-4 flex justify-between gap-3 overflow-x-auto pb-px md:h-full md:border-t-0 md:justify-center md:gap-8 md:overflow-visible md:pb-0">
                                <Popover v-for="(category, categoryIdx) in navigation.categories" :key="categoryIdx"
                                         class="flex flex-shrink-0" v-slot="{ open }">
                                    <div class="relative flex">
                                        <PopoverButton
                                            :class="[open ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-700 hover:text-gray-800', 'relative z-10 flex items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px']">
                                            {{ category.name }}
                                        </PopoverButton>
                                    </div>

                                    <transition enter-active-class="transition ease-out duration-200"
                                                enter-from-class="opacity-0" enter-to-class="opacity-100"
                                                leave-active-class="transition ease-in duration-150"
                                                leave-from-class="opacity-100" leave-to-class="opacity-0">
                                        <PopoverPanel v-slot="{ close }"
                                                      class="absolute top-full inset-x-0 text-gray-500 sm:text-sm">
                                            <!-- Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow -->
                                            <div class="absolute inset-0 top-1/2 bg-white shadow" aria-hidden="true"/>

                                            <div class="relative bg-white">
                                                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                                    <div
                                                        class="grid grid-cols-1 items-start gap-y-10 gap-x-6 pt-10 pb-12 md:grid-cols-3 lg:gap-x-8">


                                                        <!--Products-->
                                                        <div
                                                            class="grid grid-cols-1 gap-y-10 gap-x-6 lg:gap-x-8 col-span-2">
                                                            <div>
                                                                <p id="products-heading"
                                                                   class="font-medium text-gray-900">Oferta
                                                                    produktowa</p>
                                                                <div
                                                                    class="mt-4 border-t border-gray-200 pt-6 sm:grid sm:grid-cols-3 sm:gap-x-6">
                                                                    <ul role="list" aria-labelledby="products-heading"
                                                                        class="space-y-6 sm:space-y-4">
                                                                        <li v-for="item in category.products[0]"
                                                                            :key="item.name" class="flex">
                                                                            <router-link
                                                                                :to="{ name: 'offer', query: {category: item.href }}"
                                                                                @click="close()"
                                                                                class="hover:text-gray-800">
                                                                                {{ item.name }}
                                                                            </router-link>
                                                                        </li>
                                                                    </ul>
                                                                    <ul role="list" aria-label="More products"
                                                                        class="mt-6 space-y-6 sm:mt-0 sm:space-y-4">
                                                                        <li v-for="item in category.products[1]"
                                                                            :key="item.name" class="flex">
                                                                            <router-link
                                                                                :to="{ name: 'offer', query: {category: item.href }}"
                                                                                @click="close()"
                                                                                class="hover:text-gray-800">
                                                                                {{ item.name }}
                                                                            </router-link>
                                                                        </li>
                                                                    </ul>
                                                                    <ul role="list" aria-label="More products"
                                                                        class="mt-6 space-y-6 sm:mt-0 sm:space-y-4">
                                                                        <li v-for="item in category.products[2]"
                                                                            :key="item.name" class="flex">
                                                                            <router-link
                                                                                :to="{ name: 'offer', query: {category: item.href }}"
                                                                                @click="close()"
                                                                                class="hover:text-gray-800">
                                                                                {{ item.name }}
                                                                            </router-link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!--Bistro-->
                                                        <div
                                                            class="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-1 lg:gap-x-8 col-span-1">

                                                            <div>
                                                                <p id="bistro-heading"
                                                                   class="font-medium text-gray-900">Oferta
                                                                    gastronomiczna</p>
                                                                <ul role="list" aria-labelledby="bistro-heading"
                                                                    class="mt-4 border-t border-gray-200 pt-6 space-y-6 sm:space-y-4">
                                                                    <li v-for="item in category.bistro"
                                                                        :key="item.name" class="flex">
                                                                        <router-link
                                                                            :to="{ name: 'offer', query: {category: item.href }}"
                                                                            @click="close()"
                                                                            class="hover:text-gray-800">
                                                                            {{ item.name }}
                                                                        </router-link>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </PopoverPanel>
                                    </transition>
                                </Popover>

                                <router-link v-for="item in navigation.other" :key="item.name" :to="{ name: item.href }"
                                             class="flex flex-shrink-0 items-center whitespace-nowrap text-sm font-medium text-gray-700 hover:text-gray-800">
                                    {{ item.name }}
                                </router-link>
                                <!--
                                <a v-for="item in navigation.other" :key="item.name" :href="item.href"
                                   class="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800">{{
                                        item.name
                                    }}</a> -->
                            </div>
                        </PopoverGroup>

                        <div class="flex-1 flex items-center justify-end">
                            <!-- Search -->
                            <a href="#" class="p-2 text-gray-400 hover:text-gray-500"
                               @click.prevent="$emit('opensearch')">
                                <span class="sr-only">Search</span>
                                <SearchIcon class="w-6 h-6" aria-hidden="true"/>
                            </a>

                            <!-- Cart -->
                            <div class="ml-4 flow-root lg:ml-8">
                                <a href="https://sklep.uchowanca.pl" class="group -m-2 p-2 flex items-center">
                                    <ShoppingBagIcon
                                        class="flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                        aria-hidden="true"/>
                                    <span
                                        class="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-800">E-Sklep</span>
                                    <span class="sr-only">Online Shop</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import {ref} from 'vue';
import {Popover, PopoverButton, PopoverGroup, PopoverPanel} from '@headlessui/vue';
import {SearchIcon, ShoppingBagIcon} from '@heroicons/vue/outline'

const navigation = {
    categories: [
        {
            name: 'Oferta',
            //TODO ADAM: Do menu powinny być brana tablica z api ze ścieżki https://cloudpanel.pl/api/uchowanca/categories - jest gotowa metoda w tym kontrolerze.
            //TODO ADAM: Tylko trzeba jednorodną tablicę podzielić na 3 części w menu w desktop. W mobile jest jedna kolumna.
            products: [
                [
                    {name: 'Warzywa i owoce', href: 'Warzywa i owoce'},
                    {name: 'Mięso i wędliny', href: 'Mięso i wędliny'},
                    {name: 'Pieczywo i ciasta', href: 'Pieczywo i ciasta'},
                    {name: 'Nabiał', href: 'Nabiał'},
                    {name: 'Artykuły śniadaniowe', href: 'Artykuły śniadaniowe'},
                    {name: 'Artykuły mrożone', href: 'Artykuły mrożone'},
                    {name: 'Garmażerka', href: 'Garmażerka'},
                    {name: 'Zdrowa żywność', href: 'Zdrowa żywność'},
                ],
                [
                    {name: 'Alkohol', href: 'Alkohol'},
                    {name: 'Napoje i soki', href: 'Napoje i soki'},
                    {name: 'Kawa i herbata', href: 'Kawa i herbata'},
                    {name: 'Słodycze', href: 'Słodycze'},
                    {name: 'Słone przekąski', href: 'Słone przekąski'},
                    {name: 'Dania gotowe i zupy', href: 'Dania gotowe i zupy'},
                    {name: 'Przetwory owocowe i warzywne', href: 'Przetwory owocowe i warzywne'},
                    {name: 'Przyprawy, sosy i oleje', href: 'Przyprawy, sosy i oleje'},
                ],
                [
                    {name: 'Artykuły sypkie', href: 'Artykuły sypkie'},
                    {name: 'Desery', href: 'Desery'},
                    {name: 'Chemia i kosmetyki', href: 'Chemia i kosmetyki'},
                    {name: 'Dla dzieci', href: 'Dla dzieci'},
                    {name: 'Dla zwierząt', href: 'Dla zwierząt'},
                    {name: 'Dom i ogród', href: 'Dom i ogród'},
                    {name: 'Artykuły farmaceutyczne', href: 'Artykuły farmaceutyczne'},
                ]
            ],
            bistro: [
                {name: 'Dania mięsne', href: 'Dania mięsne'},
                {name: 'Makarony', href: 'Makarony'},
                {name: 'Dodatki', href: 'Dodatki'},
                {name: 'Surówki i sałatki', href: 'Surówki i sałatki'},
            ],
        },
    ],
    other: [
        {name: 'Sklepy', href: 'shops'},
        {name: 'Praca', href: 'jobs'},
        {name: 'Kontakt', href: 'contact'},
    ],
}

export default {
    name: "TopMenu",
    components: {
        Popover,
        PopoverButton,
        PopoverGroup,
        PopoverPanel,
        SearchIcon,
        ShoppingBagIcon
    },
    setup() {
        return {
            navigation,
        }
    },
    created() {
        this.getCategories();
    },
    methods: {
        async getCategories() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/categories`)
                .then(response => response.json())
                .then(result => {
                    this.productCategories = result.categories;
                    console.log(result.categories)
                });
        },
    }
}
</script>

<style scoped>

</style>
